export default "__VITE_ASSET__0254fc6b__"